module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPHBhdGggZD0iTTAgMGg2NDB2NDgwSDB6IiBmaWxsPSIjMjE0NjhiIi8+CiAgPHBhdGggZD0iTTAgMGg2NDB2MzIwSDB6IiBmaWxsPSIjZmZmIi8+CiAgPHBhdGggZD0iTTAgMGg2NDB2MTYwSDB6IiBmaWxsPSIjYWUxYzI4Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/bq.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/bq.svg
// module chunks = 0